<template>
  <v-dialog v-model="show" persistent no-click-animation max-width="450">
    <div class="loading-spinner">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="logo-text">Powered by TG3D Studio</div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    show: false,
  }),
  methods: {
    setShow(data) {
      this.show = data;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.root {
  background-color: rgba(255, 255, 255, 0.75);
}
.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-style: italic;
  letter-spacing: -0.17px;
  text-align: center;
  color: #59dfe7;
}
.lds-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 5px solid #2dbdcb;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #2dbdcb transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
</style>
